export default __webpack_public_path__ + "assets/icons/personalCanada.4bef02ea.svg";